export enum TabStateEnum {
    EARNINGS = 'earnings',
    WITHDRAWALS = 'withdrawals',
}
